
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'

    class ChangePasswordDto {
        currentPassword: String;
        newPassword: String;
        confirmNewPassword: String;
    }

    @Component
    export default class ChangePassword extends AbpBase{
        @Prop({type:Boolean,default:false}) value:boolean;
        changePasswordDto: ChangePasswordDto = new ChangePasswordDto();
        saveLoading: Boolean = false;

        save(){
            (this.$refs.changePasswordForm as any).validate(async (valid: boolean)=>{
                if(valid){
                    this.saveLoading = true;
                    await this.$store.dispatch({
                        type:'user/changePassword',
                        data:this.changePasswordDto
                    }).then(()=>{
                        this.saveLoading = false;
                        (this.$refs.changePasswordForm as any).resetFields();
                        this.$Message.success(this.L('ChangePasswordSuccess'));
                        this.$emit('save-success');
                        this.$emit('input',false);
                    }).catch(()=>{
                        this.saveLoading = false;
                    });
                }
            })
        }
        cancel(){
            (this.$refs.changePasswordForm as any).resetFields();
            this.$emit('input',false);
        }
        visibleChange(value:boolean){
            if(!value){
                this.$emit('input',value);
            }else{
                (this.$refs.changePasswordForm as any).resetFields();
                this.changePasswordDto = new ChangePasswordDto();
            }
        }
        validatePassCheck = (rule:any, value:any, callback:any) => {
            if (!value) {
                callback(new Error(this.L('ConfirmPasswordMsg')));
            } else if (value !== this.changePasswordDto.newPassword) {
                callback(new Error(this.L('ConfirmPasswordNotMatch')));
            } else {
                callback();
            }
        };
        changePasswordRules={
            currentPassword:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('CurrentPassword')),trigger: 'blur'}],
            newPassword:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('NewPassword')),trigger: 'blur'}],
            confirmNewPassword:[{required:true,message:this.L('FieldIsRequired'),trigger: 'blur'}],
        }
    }
